module.exports = __webpack_public_path__ + "static/media/about-family-2.c3a81b9d.jpg";